<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>Date</th>
          <th>Time</th>
          <th>Meal</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(lunchTime, index) in lunchTimes"
          :key="index"
        >
          <td
            :class="['zero-padding', { tbc: dateIsTbc(lunchTime.date), invalid: lunchTime.invalid }]"
            @click.stop="focusInput"
          >
            <input
              type="date"
              :name="index"
              :value="lunchTime.date"
              :min="minDate"
              :max="maxDate"
              @input="updateDate"
            >
          </td>
          <td
            :class="['zero-padding', { tbc: timeIsTbc(lunchTime.time), invalid: lunchTime.invalid }]"
            @click.stop="focusInput"
          >
            <input
              type="time"
              step="300"
              :name="index"
              :value="lunchTime.time"
              @input="updateTime"
              @change="checkFormValidity"
              @keyup="checkFormValidity"
            >
          </td>
          <td class="full-width zero-padding">
            <select
              :name="index"
              :value="lunchTime.meal_name"
              @change="updateMealName"
            >
              <option
                v-for="(meal_name_value, idx) in mealNameValues"
                :key="idx"
                :value="meal_name_value"
              >
                {{ meal_name_value }}
              </option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="hasError"
      class="input-error"
    >
      <p>The following meals have errors:</p>
      <ul>
        <li
          v-for="(errorText, index) in errorTexts()"
          :key="index"
        >
          {{ errorText }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { ukShortDate } from 'lib/date-and-time-formats'
import LunchTime, { MEAL_NAME_VALUES } from '../../models/LunchTime'

export default {
  name: 'MealsTable',

  props: {
    id: {
      type: String,
      required: true
    },

    minDate: {
      type: String,
      default: null
    },

    maxDate: {
      type: String,
      default: null
    },

    lunchTimes: {
      type: Array,
      required: true
    },

    mealErrors: {
      type: Object,
      default: () => ({})
    },

    updateNestedAttribute: {
      type: Function,
      required: true
    }
  },

  computed: {
    hasError () {
      return Object.keys(this.mealErrors).length > 0
    },

    mealNameValues () {
      return MEAL_NAME_VALUES
    }
  },

  methods: {
    focusInput (event) {
      if (event.target.tagName === 'TD') {
        event.target.querySelector('input').focus()
      }
    },

    timeIsTbc (mealTime) {
      return mealTime === 'TBC'
    },

    dateIsTbc (mealDate) {
      return mealDate === null
    },

    errorTexts () {
      return Object.entries(this.mealErrors).map((entry) => {
        const errors = entry[1]
        const mealNumber = parseInt(entry[0]) + 1

        if (errors.time !== undefined) {
          return `Meal number ${mealNumber} has an invalid time`
        } else if (errors.date.includes('outside_range')) {
          const formattedTravelDate = ukShortDate(this.minDate)
          const formatteReturnDate = ukShortDate(this.maxDate)

          return `Meal number ${mealNumber} is invalid. 
                  Date must be between ${formattedTravelDate} & ${formatteReturnDate}`
        } else if (errors.date.includes('invalid')) {
          return `Meal number ${mealNumber} has an invalid date`
        } else {
          return `Meal number ${mealNumber} is invalid`
        }
      })
    },

    updateDate (event) {
      this.updateNestedAttribute(this.id, LunchTime, 'date', event.target.name, event.target.value)
      // this.checkFormValidity()
    },

    updateTime (event) {
      this.updateNestedAttribute(this.id, LunchTime, 'time', event.target.name, event.target.value)
      // this.checkFormValidity()
    },

    updateMealName (event) {
      this.updateNestedAttribute(this.id, LunchTime, 'meal_name', event.target.name, event.target.value)
    }
  }
}
</script>
